export default "__VITE_ASSET__$ongDCha__"